<template>
  <modal-window :loading="loading" v-on:close="$emit('closeChangeEditor')">
    <template slot="header">
      <p class="modal-card-title">{{ header }}</p>
      <button class="delete" v-on:click="$emit('closeChangeEditor')" aria-label="close"></button>
    </template>
    <template slot="body">
      <div class="columns" id="edit-header">
        <div class="column">
          <label class="label">Change type</label>
        </div>
        <div class="column">
          <label class="label">Change group</label>
        </div>
        <div class="column">
          <label class="label">Private change</label>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <div class="control">
              <b-tooltip
                position="is-right"
                multilined
                label="Type of the currnet change: added, deprecated, etc."
              >
                <div class="select">
                  <select v-model="selectedChangeType">
                    <option
                      v-for="(type, index) in changeTypes"
                      :key="index"
                      v-bind:value="type"
                    >{{ type }}</option>
                  </select>
                </div>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <div class="control">
              <b-tooltip
                position="is-bottom"
                label="Group of the currnet change: Engine, Exports, etc."
              >
                <div class="select">
                  <select v-model="selectedChangeGroupId">
                    <option
                      v-for="(group, index) in changeGroups"
                      :key="index"
                      v-bind:value="group.id"
                    >{{ group.name }}</option>
                  </select>
                </div>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-tooltip
              position="is-bottom"
              multilined
              label="Specified, either should the change be shown to the users or not"
            >
              <b-switch v-model="newChangeIsPrivate"></b-switch>
            </b-tooltip>
          </div>
        </div>
      </div>

      <!-- TRANSLATIONS -->
      <label class="label">English</label>
      <div class="box">
        <b-tooltip position="is-right" label="Text of the change: something added, fixed, etc.">
          <label class="label">Text</label>
        </b-tooltip>
        <b-field
          v-bind:type="{'is-danger':  newChangeText.length < 5 && saveClicked}"
          v-bind:message="{'Here should be some text...' : newChangeText.length < 5 && saveClicked }"
        >
          <b-input
            v-model="newChangeText"
            placeholder="added new awsome feature (not a bug!)"
            maxlength="1000"
            spellcheck="true"
          ></b-input>
        </b-field>

        <b-collapse :open.sync="enIsOpen">
          <button
            class="button is-light is-small collapse-button"
            slot="trigger"
          >{{enIsOpen ? collapseText : expandText}}</button>
          <div class="field">
            <b-tooltip position="is-right" label="Detrav know what it is, ask for him">
              <label class="label">Annotation</label>
            </b-tooltip>
            <b-input
              v-model="newChangeAnnotation"
              placeholder="¯\_(ツ)_/¯"
              maxlength="1000"
              spellcheck="true"
            ></b-input>
          </div>

          <div class="field">
            <b-tooltip
              position="is-right"
              label="Web page of the documentation, related with this change"
            >
              <label class="label">Documentation link</label>
            </b-tooltip>

            <b-input
              v-model="newChangeDocLink"
              placeholder="https://somefarinthegalaxy.com/documentation"
            ></b-input>
          </div>
        </b-collapse>
      </div>

      <label class="label">Russian</label>
      <div class="box">
        <b-tooltip
          position="is-right"
          label="Text of the change on russian: something added, fixed, etc."
        >
          <label class="label">Text</label>
        </b-tooltip>
        <b-field
          v-bind:type="{'is-danger':  newChangeTextRu.length < 5 && saveClicked}"
          v-bind:message="{'Here should be some text...' : newChangeTextRu.length < 5 && saveClicked }"
        >
          <b-input
            v-model="newChangeTextRu"
            v-bind:class="{ 'is-danger':  newChangeTextRu.length < 5 && saveClicked}"
            placeholder="added new awsome feature (not a bug!)"
            maxlength="1000"
            spellcheck="true"
          ></b-input>
        </b-field>

        <b-collapse :open.sync="ruIsOpen">
          <button
            class="button is-light is-small collapse-button"
            slot="trigger"
          >{{ruIsOpen ? collapseText : expandText}}</button>
          <div class="field">
            <b-tooltip position="is-right" label="Detrav know what it is, ask for him">
              <label class="label">Annotation</label>
            </b-tooltip>
            <b-input
              v-model="newChangeAnnotationRu"
              placeholder="¯\_(ツ)_/¯"
              maxlength="1000"
              spellcheck="true"
            ></b-input>
          </div>

          <div class="field">
            <b-tooltip
              position="is-right"
              label="Web page of the documentation, related with this change"
            >
              <label class="label">Documentation link</label>
            </b-tooltip>

            <b-input
              v-model="newChangeDocLinkRu"
              placeholder="https://somefarinthegalaxy.com/documentation"
            ></b-input>
          </div>
        </b-collapse>
      </div>
      <!-- END TRANSLATIONS -->
      <div class="field">
        <b-tooltip label="Web page of the task, related with this change" position="is-right">
          <label class="label">Task link</label>
        </b-tooltip>
        <b-input
          v-model="newChangeTaskLink"
          placeholder="https://somefarinthegalaxy.com/product/task123"
        ></b-input>
      </div>

      <div class="field">
        <b-tooltip
          label="Web page of the merge request, related with this change"
          position="is-right"
        >
          <label class="label">Merge Request link</label>
        </b-tooltip>
        <b-input
          v-model="newChangeMergeLink"
          placeholder="https://somefarinthegalaxy.com/repo/merg24"
        ></b-input>
      </div>

      <div class="field">
        <b-tooltip label="Tags of the change" position="is-right">
          <label class="label">Tags</label>
        </b-tooltip>
        <b-taginput
          placeholder="Add a tag: OpenSource, Desktop, etc."
          v-model="newTags"
          ellipsis
          icon="label"
          :data="filteredTags"
          :allow-new="true"
          autocomplete
          @typing="getFilteredTags"
          :before-adding="beforeTagAdding"
        ></b-taginput>
      </div>

      <div class="field">
        <b-tooltip label="Product version, whitch includes the change" position="is-right">
          <label class="label">Version</label>
        </b-tooltip>

        <b-select v-model="selectedVersion">
          <option
            v-for="(version, index) in versions"
            :key="index"
            v-bind:value="version.id"
          >{{ version.text }}</option>
        </b-select>
      </div>
    </template>
    <template slot="footer">
      <button class="button is-success" v-on:click="submit()" v-on:keyup.enter="submit()">Save</button>
      <button class="button" v-on:click="$emit('closeChangeEditor')">Cancel</button>
    </template>
  </modal-window>
</template>

<script>
import ModalWindow from "./ModalWindow";
import {
  getVersionText,
  getVersionDestructor,
  getVersionDestructorArr
} from "./Utils";

export default {
  name: "change-editor",
  components: { ModalWindow },
  props: {
    changeId: Number,
    productId: Number,
    header: String
  },
  data() {
    return {
      tags: ["Auckland", "Wellington", "Very long string that would overflow"],
      newChangeText: "",
      newChangeAnnotation: "",
      newChangeDocLink: "",

      newChangeTextRu: "",
      newChangeAnnotationRu: "",
      newChangeDocLinkRu: "",

      newChangeTaskLink: "",
      newChangeMergeLink: "",

      newChangeIsPrivate: 0,
      newTags: [],
      tagsIds: [],
      allTags: [],
      filteredTags: [],

      versions: [],
      currentVersion: { id: 1 },
      selectedVersion: 1,

      changeTypes: [],
      selectedChangeType: "Added",
      changeGroups: [],
      selectedChangeGroupId: -1,

      //form validation data
      textIsValid: true,
      saveClicked: false,

      recordProcessing: false, //should prevent record duplicate creating
      loading: false,

      enIsOpen: false,
      ruIsOpen: false,
      collapseText: "Less",
      expandText: "More"
    };
  },
  computed: {
    userId: function() {
      return this.HTTP.getUserProfile().id;
    },
    tagsArray: function() {
      if (this.newTags != null && this.newTags.length > 0) {
        let parts = this.newTags.split(",");
        let partsObj;
        let partsArray = [];
        parts.forEach(element => {
          if (element.trim().length > 0) {
            partsObj = {
              productId: this.productId,
              group: {
                name: element.trim()
              }
            };
            partsArray.push(partsObj);
          }
        });
        return partsArray;
      } else return null;
    }
  },
  methods: {
    createChange() {
      this.HTTP.post(`changes`, {
        versionId: this.selectedVersion,
        documentationLink: this.newChangeDocLink,
        taskLink: this.newChangeTaskLink,
        mergeRequestLink: this.newChangeMergeLink,
        isPrivate: this.newChangeIsPrivate,
        translations: [
          {
            language: "English",
            text: this.newChangeText,
            annotation: this.newChangeAnnotation,
            documentationLink: this.newChangeDocLink
          },
          {
            language: "Russian",
            text: this.newChangeTextRu,
            annotation: this.newChangeAnnotationRu,
            documentationLink: this.newChangeDocLinkRu
          }
        ],
        type: this.selectedChangeType,
        groupId: this.selectedChangeGroupId,
        changeTagRels: this.newTags.map(t => ({
          tag: { name: t }
        }))
      })
        .then(response => {
          this.recordProcessing = false;
          this.$emit("closeChangeEditor");
        })
        .catch(e => {
          this.recordProcessing = false;
          console.log(e.text);
        });
    },
    editChange(changeId) {
      this.HTTP.put(`changes/` + changeId, {
        id: changeId,
        versionId: this.selectedVersion,
        taskLink: this.newChangeTaskLink,
        mergeRequestLink: this.newChangeMergeLink,
        documentationLink: this.newChangeDocLink,
        isPrivate: this.newChangeIsPrivate,
        translations: [
          {
            language: "English",
            text: this.newChangeText,
            annotation: this.newChangeAnnotation,
            documentationLink: this.newChangeDocLink
          },
          {
            language: "russian",
            text: this.newChangeTextRu,
            annotation: this.newChangeAnnotationRu,
            documentationLink: this.newChangeDocLinkRu
          }
        ],
        type: this.selectedChangeType,
        groupId: this.selectedChangeGroupId,
        changeTagRels: this.newTags.map(t => ({
          tag: { name: t },
          changeId: changeId
        }))
      })
        .then(response => {
          this.recordProcessing = false;
          this.$emit("closeChangeEditor");
        })
        .catch(e => {
          this.recordProcessing = false;
          console.log(e.text);
        });
    },

    getChange(id) {
      this.loading = true;
      this.HTTP.get("changes/" + id)
        .then(response => {
          if (
            response.data.translations != null &&
            response.data.translations.length > 0
          ) {
            response.data.translations.forEach(translation => {
              if (translation.language.toLowerCase() == "english") {
                this.newChangeText = translation.text;
                this.newChangeAnnotation = translation.annotation;
                this.newChangeDocLink = translation.documentationLink;
              } else if (translation.language.toLowerCase() == "russian") {
                this.newChangeTextRu = translation.text;
                this.newChangeAnnotationRu = translation.annotation;
                this.newChangeDocLinkRu = translation.documentationLink;
              }
            });
          }

          this.newChangeTaskLink = response.data.taskLink;
          this.newChangeMergeLink = response.data.mergeRequestLink;
          this.newChangeIsPrivate = response.data.isPrivate;
          this.selectedVersion = response.data.versionId;

          this.selectedChangeType = response.data.type;
          this.selectedChangeGroupId = response.data.groupId;

          let tagsIds = [];
          if (response.data.changeTagRels != null) {
            response.data.changeTagRels.forEach(tag => {
              tagsIds.push(tag.tagId);
            });
          }
          this.tagsIds = tagsIds;
          this.getTagNames();
          this.loading = false;
          console.log(response.data);
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
        });
    },
    submit() {
      console.log("recordProcessing - " + this.recordProcessing);
      if (!this.recordProcessing) {
        this.saveClicked = true;

        if (this.newChangeText.length >= 5) {
          this.recordProcessing = true;
          if (this.changeId <= 0) this.createChange();
          else this.editChange(this.changeId);
        }
      }
    },

    //versions
    getVersions() {
      this.HTTP.get(`productVersions/product/` + this.productId + `/1/10000`)
        .then(response => {
          this.versions = getVersionDestructorArr(response.data.entities);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCurrentVersion() {
      this.loading = true;
      this.HTTP.get("productVersions/current/" + this.productId)
        .then(response => {
          this.currentVersion = getVersionDestructor(response.data);
          this.selectedVersion = response.data.id;
          let flag = true;
          for (let i = 0; i < this.versions.length; i++) {
            if (this.versions[i].id === this.selectedVersion) {
              flag = false;
            }
          }
          if (flag) {
            // Added by Detrav
            console.log("unshift");
            this.versions.unshift(getVersionDestructor(response.data));
            //console.log(this.versions);
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
        });
    },
    //end versions

    getChangeTypes() {
      this.HTTP.get("changes/changeTypes")
        .then(response => {
          this.changeTypes = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getChangeGroups() {
      this.HTTP.get("ChangeGroups/product/" + this.productId)
        .then(response => {
          this.changeGroups = response.data;
          //if create new change
          if (this.changeId <= 0) {
            this.selectedChangeGroupId = response.data[0].id;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getTagNames() {
      this.HTTP.get(`changes/tags/` + this.changeId)
        .then(response => {
          this.newTags = response.data.map(t => t.name);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getAllTagNames() {
      this.HTTP.get(`changes/tags/`)
        .then(response => {
          this.allTags = response.data.map(t => t.name);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getFilteredTags(text) {
      this.filteredTags = this.allTags.filter(option => {
        return option.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    beforeTagAdding(tag) {
      for (let k of this.newTags) {
        if (tag.toLowerCase() == k.toLowerCase()) return false;
      }
      return true;
    }
  },

  created() {
    this.loading = true;
    //add listeners
    document.addEventListener("keydown", this.keyDownListener);
    // end add listeners
    this.getChangeTypes();
    this.getChangeGroups();
    this.getAllTagNames();
    this.getVersions();

    //if edit change
    if (this.changeId > 0) {
      this.getChange(this.changeId);
    } else {
      this.getCurrentVersion();
    }
  },
  destroyed: function() {
    document.removeEventListener("keydown", this.keyDownListener);
  }
};
</script>

<style scoped>
#edit-header {
  margin-bottom: 0px;
  padding: 0px;
}
#edit-header .column {
  margin-bottom: 0px;
  padding-bottom: 0.2rem;
}
.collapse-button {
  width: -webkit-fill-available;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeEditor.Vue